export enum PutOrganizationTenantResultType {
    Success = 'The tenant has been configured successfully.',
    Invalid = 'The tenant configuration was invalid.',
    Unauthorized = 'You are unauthorized to configure this tenant.',
    Unknown = 'An unknown error has occurred. Please try again.',
    Timeout = `The tenant couldn't be configured because the request took too long.`
}
